import { useContext } from 'react';
import BrowserHistoryContext from 'contexts/BrowserHistory/BrowserHistoryContext';

const useLocation = () => {
    const historyContext = useContext(BrowserHistoryContext);
    return historyContext.state?.location;
};

export default useLocation;
